import React, { Component } from "react"
import { Button, Icon, Affix, message, Row, Upload, Table, Modal} from "antd"
import { observer, inject } from "mobx-react"
import { observable } from "mobx"
import config from "app/config"
import closeIcon from "app/styles/images/sp/close.svg"
import UploadModal from "app/components/normal/BasicModal/UploadModal"
import MaterialModal from "app/components/normal/MaterialModal"
import cx from "classnames"
import getPathogenList from "app/utils/pathogenDispose"
import deleteAbleIcon from "app/styles/images/sp/delete.svg"
import titleIcon from "app/styles/images/sp/title.svg"
import deleteWarningIcon from "app/styles/images/sp/delete-warning.svg"
import { getToken } from "app/api/localTools"
import Store from "app/stores/pgd/report"

@inject("pgdDataManageDetail", "auth") @observer
export default class extends Component {
  @observable confirmModalOpened = false
  @observable uploadModalOpened = false
 
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
    this.state = { 
      showDiagnosisModal:false,
      DiagnosisList:[],
      showDeleteDiagnosisModal: false,
      dataSingle: {},
    }

  }
  componentDidMount() {
    let { pgdDataManageDetail } = this.props
    const { auth } = this.props
    auth.getPushAuth()

    pgdDataManageDetail.loadFamilyInfo()
      .catch(
        err => {
          message.error(err.message)
        }
      )
  }

  saveTableData = () => {
    const { saveDatas, updateTableData } = this.props.pgdDataManageDetail

    return saveDatas()
      .then(result => {
        updateTableData()
        message.success("保存成功")
      }, error => {
        message.error(error.message)
        return Promise.reject(error)
      })
  }

  runProject = () => {
    const { selectedData } = this.props.pgdDataManageDetail
    this.saveTableData()
      .then(() => {
        if (selectedData.length > 0) {
          this.confirmModalOpened = true
        } else {
          message.error("还未勾选数据")
        }
      })
  }

  startRunTask = () => {
    this.props.pgdDataManageDetail.runTask()
      .then(() => {
        message.success("数据已开始运行")
        this.closeModal(('confirmModalOpened'))
      }, error => {
        message.error(error.message)
      })
  }

  showUploadModal = () => {
    this.props.pgdDataManageDetail.getAppInfo()
  }

  dismissUploadModal = () => {
    this.props.pgdDataManageDetail.clearAppInfo()
  }

  closeModal = (modal) => {
    this.confirmModalOpened = false
  }
  closeModalDiagnosis = (modal) => {
    this.setState({
      [modal]: false
    })
  }

  showDiagnosisModal = () => {
    const { getGroupDiagnosisListById  } = this.store
    const {familyId}=this.props.pgdDataManageDetail
    this.setState({
      showDiagnosisModal: true,
    })
    getGroupDiagnosisListById(familyId, 0)

  }
  showDeleteDiagnosisModal= (record) => {
    this.setState({
      showDeleteDiagnosisModal: true,
      dataSingle: record,
    })
  }
      deleteDiagnosisReport= (groupId) => {
        const { deleteDiagnosisReport  } = this.store
        const { dataSingle } = this.state
        const { getGroupDiagnosisListById  } = this.store
   
      const familyInfo=this.props.pgdDataManageDetail.familyInfo
        
        deleteDiagnosisReport(groupId, dataSingle.id)
          .then(res => {
            message.success("报告删除成功")
            setTimeout(() => {
              getGroupDiagnosisListById(familyInfo.id, 0)
              this.setState({ showDeleteDiagnosisModal: false })
            }, 1500)
    
          }, err => {
            message.error(err.message)
          })
      }
      closeDeleteModal = () => {
        this.setState({ showDeleteModal: false,showDeleteDiagnosisModal:false })
      }
  render() {
    const {
      familyInfo: { id, name, createTime },
      appInfo,
      saveReady,
      runReady
    } = this.props.pgdDataManageDetail
   
    const familyInfo=this.props.pgdDataManageDetail.familyInfo
    let {
      dataSingle,
      showDeleteDiagnosisModal
    } = this.state
    const { auth: { pushAuth } } = this.props
    let saveBtnClass = cx({
      "green-btn save-btn": true,
      "disable": !saveReady
    })
    let runBtnClass = cx({
      "green-btn run-btn": true,
      "disable": !runReady
    })

    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={0}
      >
        <div className="search-bar">
          <div className="left">
            <div>数据类型：PGD数据</div>
            <div>家系名称：{name}</div>
            <div>创建时间：{createTime}</div>
          </div>
          <div className="right">
            <button
              className="green-btn run-btn"
              type="primary"
              style={{ marginRight: '10px' }} 
              size="default"
              onClick={this.showDiagnosisModal}>
              <Icon type="plus" />诊断报告
            </button>
            <Button
              className="add-btn"
              type="primary"
              size="default"
              onClick={this.showUploadModal}>
              <Icon type="plus" />添加数据
            </Button>
            <button
              disabled={saveReady ? "" : "disabled"}
              className={saveBtnClass}
              type="primary"
              size="default"
              onClick={this.saveTableData}>
              <Icon type="save" /> 保存
            </button>
            <button
              disabled={runReady ? "" : "disabled"}
              className={runBtnClass}
              type="primary"
              size="default"
              onClick={this.runProject}>
              <Icon type="caret-right" /> 开始运行
            </button>
          </div>
        </div>
        {
          this.confirmModalOpened && (
            <MaterialModal
              className="pgd-datamanage-confirm-modal"
              title="数据及引物确认"
              width={900}
              height={450}
              visible={true}
              footer={(
                <Row type="flex" justify="space-between" align="middle">
                  <button className="cancel-btn" onClick={() => this.closeModal('confirmModalOpened')}>有问题，返回修改</button>
                  <button className="ok-btn" onClick={this.startRunTask}>
                    <Icon type="caret-right" /> 确认无误，开始运行
                  </button>
                </Row>)}
            >
              <img
                className="pgx-modal-close"
                src={closeIcon}
                alt="关闭对话框"
                onClick={() => this.closeModal('confirmModalOpened')}
              />
              {this.renderDatas()}
            </MaterialModal>
          )
        }
        {/* 诊断报告modal */}
        {this.state.showDiagnosisModal &&
          <DiagnosisModal
            ref="DiagnosisModal"
            store={this.store}
            data={familyInfo}
            onClose={() => this.closeModalDiagnosis("showDiagnosisModal")}
            showDeleteDiagnosisModal={this.showDeleteDiagnosisModal}
          />
        }
        {/* 删除样本列表单条modal */}
        {showDeleteDiagnosisModal &&
          <Modal
            className="pgx-modal reportcard-delete-modal"
            title={(
              <Row className="pgx-modal-title" type="flex" justify="center" align="middle" >
                <img src={titleIcon} alt="" />
                <div className="content">报告删除确认</div>
                <img src={titleIcon} alt="" />
              </Row>
            )}
            visible
            footer={(
              <Row
                type="flex"
                justify="center"
                align="middle"
                onClick={
                  () => this.deleteDiagnosisReport(familyInfo.id)
                }
              >
                <button className="pgx-modal-delete-btn" type="primary">删除</button>
              </Row>
            )}
          >
            <img
              className="pgx-modal-close"
              src={closeIcon}
              alt="关闭对话框"
              onClick={this.closeDeleteModal}
            />
            <Row type="flex" justify="center" align="middle">
              {dataSingle.filename}
            </Row>
            <Row className="warning-line1" type="flex" justify="center" align="middle" gutter={8}>
              <img src={deleteWarningIcon} alt="" />
              <div>您确定要删除本条报告吗？</div>
            </Row>
          </Modal>
        }
        {appInfo &&
          <UploadModal
            visible
            verifyLimsPgdFamily={pushAuth.verifyLimsPgdFamily}
            info={appInfo}
            groupId={id}
            onCancel={this.dismissUploadModal}
            type="singleGroup"
          />
        }
      </Affix>
    )
  }

  renderDatas = () => {
    const { composedData } = this.props.pgdDataManageDetail
    return (
      <div className="content-data">
        {Object.keys(composedData).map(groupId =>
          <div key={groupId} className="confirm-data-group" >
            {composedData[groupId].map(this.renderDataItem)}
          </div>
        )}
      </div>
    )
  }

  renderDataItem = (sample) => {
    const pathogenList = getPathogenList(sample.relationName)

    return (
      <div className="confirm-data-item" key={sample.id}>
        <div className="item-relation-name">{sample.relationName}</div>
        <div className="item-pathogen">{pathogenList.get(sample.pathogen)}</div>
        <div className="item-filename">{sample.filename}</div>
        <div className="item-sample-name">{sample.sampleName}</div>
        <div className="item-primers">
          {sample.primers.map(primer => <span key={primer}>{primer}</span>)}
        </div>
      </div>
    )
  }
}
@observer
class DiagnosisModal extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      dataSingle: {},
      groupName: props.data.name
    }
    
    this.deleteColumns = [
      {
        title: "文件名称",
        dataIndex: "filename",
        className: "ta-c",
        render: (text, record, index) => {
          return ( 
            <Row>
                <a 
                  href={`${config.backend}/pgs/reports/test/preview/${record.id}`} 
                  target="_blank"
                >
                    {text}
                </a>
            </Row>
          )
        }
      },{
        title: "上传时间",
        dataIndex: "uploadTime",
        className: "ta-c",
      }, {
      title: "操作",
      dataIndex: "oprator",
      width: 250,
      className: "ta-c",
      render: (text, record, index) => {
        return (
          <Row className="table-oprator ta-c" type="flex" justify="center" align="middle">
            <img
              className="cursor-p"
              alt="删除"
              src={deleteAbleIcon}
              onClick={() => props.showDeleteDiagnosisModal(record)} />
          
              <a 
                href={`${config.backend}/pgs/reports/test/download/${record.id}`}
                title="下载"
              >
                <Icon 
                type="download" 
                style={{ fontSize: '15px', color: '#08c',marginLeft:"10px",fontWeight:'bold' }}
                />
              </a>
          </Row>
        )
      }
    }]
    
  }

  render() {
    const { onClose,data,store: { getGroupDiagnosisListById }} = this.props
    const { DiagnosisList } =  this.props.store
    
    const token = getToken()
    const uploadProps = {
      name: 'file',
      multiple: true,
      action: `${config.backend}/pgd/reports/test/upload/${data.id}`,
      headers: {
        authorization:  "Bearer " + token
      },
      onChange(info) {
        if (info.file.status !== 'uploading') {
          // console.log(info.file, info.fileList)
        }
        if (info.file.status === 'done') {
          message.success(`${info.file.name} 文件上传成功`)
          getGroupDiagnosisListById(data.id, 0)

        } else if (info.file.status === 'error') {
          message.error(`${info.file.name} 文件上传失败`)
        }
      }
    }
    
    return (
      <MaterialModal
        className="pgs-reportcard-edit-modal"
        title="诊断报告列表"
        visible
        width={1160}
        footer={(
          <Row type="flex" justify="center" align="middle">
           
            <button
              className="delete-group-btn"
              onClick={onClose}
            >
              关闭
            </button>
          </Row>
        )}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={onClose}
        />
        <Row type='flex' justify='start' align='middle' className='subtitle subtitle2'>
          {/* <button className="primary-btn confirm" onClick={()=>this.UploadkDiagnosis()}>上传</button> */}
          <Upload
              className="pull-left"
              beforeUpload={this.UploadkDiagnosis}
              {...uploadProps}
            >
                <Button className="primary-btn confirm ">
                  上传文件
                </Button>
            </Upload>
        </Row>
        <Table
          columns={this.deleteColumns}
          rowKey={record => record.id + "delete"}
          scroll={{ y: 500 }}
          className="delete-table"
          dataSource={DiagnosisList} pagination={false}
        />

        {/* 删除确认modal */}
      </MaterialModal>
    )
  }

  // 上传样本表
  UploadkDiagnosis = (file) => {
    // 判断文件类型
    const istype = file.type === 'image/jpeg' 
    || file.type === 'image/png'
    || file.type === 'image/jpg'
    || file.type === 'application/pdf'
    if (!istype) {
      message.error('只能上传 JPG/PNG/PDF 格式的文件!')
      return false // 返回 false 阻止上传
    }
    // 如果文件满足条件，允许上传
    return true
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgd/data_manage_detail/containers/DataHeader.js